import { ROUTE_NAMES, USER_ACTIONS, USER_SUBJECTS } from '@/utils/const.js';

const SerialNumbers = () => import('./pages');

const moduleRoute = {
  path: 'manufacturing/serial-numbers',
  name: 'SerialNumbers',
  component: SerialNumbers,
  meta: {
    allowAnonymous: false,
    ability: {
      subject: USER_SUBJECTS.SERIAL_NUMBERS,
      action: USER_ACTIONS.READ,
    },
    isNextAppPage: true,
  },
};

export default (router) => {
  router.addRoute(ROUTE_NAMES.BASE_LAYOUT, moduleRoute);
};
